<template>
  <section id="search" ref="search">
    <div id="banner" class="banner-search animate__animated animate__fadeIn">
      <div class="swiper-container swiper-container-a">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(slide, index) in swiperSlides" :key="index">
            <a class="boxa" @click="See(slide.detailUrl)">
              <picture>
                <source media="(min-width: 768px)"
                  :srcset="url + (locale == 'en' || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null ? slide.pcImgUrl : slide.pcImgUrlCn)"
                  :ref="slide.id"
                  :title="locale == 'en' || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null ? slide.title : slide.titleCn">
                <source media="(min-width: 1px)"
                  :srcset="url + (locale == 'en' || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null ? slide.phoneImgUrl : slide.phoneImgUrlCn)"
                  :ref="slide.id"
                  :title="locale == 'en' || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null ? slide.title : slide.titleCn">
                <img :ref="slide.id"
                  :src="url + (locale == 'en' || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null ? slide.pcImgUrl : slide.pcImgUrlCn)"
                  :title="locale || slide.pcImgUrlCn == '' || slide.pcImgUrlCn == null == 'en' ? slide.title : slide.titleCn">
              </picture>
              <!-- <img class="hidden-xs" :ref="slide.id" :src="url + slide.pcImgUrl" :title="slide.title" />
              <img class="visible-xs" :ref="slide.id" :src="url + slide.phoneImgUrl" :title="slide.title"/> -->
            </a>
          </div>
        </div>
      </div>
      <div v-if="swiperSlides.length > 1" class="swiper-button-next swiper-button-next-a iconfontmy icon-enter"
        slot="navigation"></div>
      <div v-if="swiperSlides.length > 1" class="swiper-button-prev swiper-button-prev-a iconfontmy icon-return"
        slot="navigation"></div>
      <div class="swiper-pagination swiper-pagination-a swiprRem" slot="pagination"></div>
    </div>

    <div id="main" style="padding-top:0">
      <div class="container">
        <div class="headline">
          <h5 style="visibility: hidden;">KLM</h5>
        </div>
        <!-- 选择 -->
        <div class="selector-wrapper">
          <!-- 是否显示 -->
          <div id="model-electric" class="range-outer-wrapper">
            <el-select name="carStatus" id="carStatus" class="carStatus" v-model="carStatus"
              @change="queryCarStatus(carStatus)" popper-class="select-option"
              :placeholder="$t('search.wrapper.status')">
              <el-option selected :value="null" :label="$t('search.wrapper.status')">{{ $t('search.wrapper.status')
                }}</el-option>
              <el-option :value="item.id" v-for="item in carStatusLists" :key="item.id"
                :label="locale == 'en' ? item.nameEn : item.name">
              </el-option>
            </el-select>
          </div>
          <!-- 是否电车 -->
          <div id="model-electric" class="range-outer-wrapper">
            <el-select name="fueltype" id="fueltype" class="fueltypeId" v-model="fueltypeId"
              @change="queryElectric(fueltypeId)" popper-class="select-option"
              :placeholder="$t('search.wrapper.fueltype')">
              <el-option selected :value="null" :label="$t('search.wrapper.fueltype')">{{ $t('search.wrapper.fueltype')
                }}</el-option>
              <el-option :value="item.id" v-for="item in typeElectricLists" :key="item.id"
                :label="locale == 'en' ? item.nameEn : item.name">
              </el-option>
            </el-select>
          </div>
          <!-- 品牌 -->
          <div id="model-wrapper" class="range-outer-wrapper">
            <!-- <select name="brand" id="model" class="selector" v-model="carBrandId" @change="queryBrand(carBrandId)">
              <option selected value="null">{{$t('search.wrapper.brand')}}</option>
              <option :value="item.id" v-for="item in carBrandsList" :key="item.id">{{item.carBrand}}</option>
            </select> -->
            <el-select name="brand" id="model" class="selector" v-model="carBrandId" @change="queryBrand(carBrandId)"
              popper-class="select-option" :placeholder="$t('search.wrapper.brand')">
              <el-option selected :value="null" :label="$t('search.wrapper.brand')">{{ $t('search.wrapper.brand')
                }}</el-option>
              <el-option :value="item.id" v-for="item in carBrandsList" :key="item.id"
                :label="locale == 'en' ? item.carBrandEn : item.carBrand">
              </el-option>
            </el-select>
          </div>
          <!-- 车型 -->
          <!-- <div id="model-wrapper" class="range-outer-wrapper">
            <select name="model" id="model" class="selector" v-model="carSeriesId" @change="querySeries(carSeriesId)">
              <option selected value="null">{{$t('search.wrapper.model')}}</option>
              <option :value="carSeries.carSeriesId" v-for="carSeries in carSeriesAndModelsList" :key="carSeries.carSeriesId">{{carSeries.carSeriesName}}</option>
            </select>
          </div> -->
          <!-- 月份 -->
          <div id="year-wrapper" class="range-outer-wrapper">
            <p>{{ yearTitle }}</p>
            <div class="range-wrapper">
              <div class="num-wrapper">
                <p>{{ $t('search.wrapper.year') }}</p>
                <input type="text" id="year" :value="yearText" readonly>
              </div>
              <div id="year-range">
                <vue-slider @change="changeYear('on')" @drag-end="getYear" v-model="yearValue" :enable-cross="false"
                  :dragOnClick="true" :min="2000" :max="new Date().getFullYear()">
                </vue-slider>
              </div>
            </div>
          </div>
          <!-- 里程 -->
          <div id="mileage-wrapper" class="range-outer-wrapper">
            <p>{{ mileageTitle }}</p>
            <div class="range-wrapper">
              <div class="num-wrapper">
                <p>{{ $t('search.wrapper.mileage') }}</p>
                <input type="text" id="mileage" v-model="mileageText" readonly>
              </div>
              <div id="mileage-range">
                <vue-slider @change="changeMileage('on')" @drag-end="getMileage" v-model="mileageValue"
                  :enable-cross="false" :dragOnClick="true" :interval="10000" :min="0" :max="150000">
                </vue-slider>
              </div>
            </div>
          </div>
          <!-- 价格 -->
          <div id="price-wrapper" class="range-outer-wrapper">
            <!-- <select name="price" id="price" class="selector" v-model="pricesCuttent" @change="queryPrice(pricesCuttent)">
              <option selected value="null">{{$t('search.wrapper.price')}}</option>
              <option :value="item.priceValue" v-for="(item, index) in pricesList" :key="index">{{item.txt}}</option>
            </select> -->
            <el-select name="price" id="price" class="selector" v-model="pricesCuttent"
              @change="queryPrice(pricesCuttent)" popper-class="select-option"
              :placeholder="$t('search.wrapper.price')">
              <el-option selected :value="null" :label="$t('search.wrapper.price')">{{ $t('search.wrapper.price')
                }}</el-option>
              <el-option :value="item.priceValue" v-for="(item, index) in pricesList" :key="item.index"
                :label="locale == 'en' ? item.txtEn == '' ? item.txt : item.txtEn : item.txt">
              </el-option>
            </el-select>
            <!-- <p>{{priceTitle}}</p>
            <div class="range-wrapper">
              <div class="num-wrapper">
                <p>Price</p>
                <input type="text" id="price" v-model="priceText" readonly>
              </div>
              <div id="price-range">
                <vue-slider 
                  @change="changePrice('on')"
                  @drag-end="getPrice"
                  v-model="priceValue" 
                  :enable-cross="false" 
                  :dragOnClick="true"
                  :interval="50000"
                  :min="0"
                  :max="3000000">
                </vue-slider>
              </div>
            </div> -->
          </div>
          <div class="clear" @click="carInventoryList()">{{ $t('search.wrapper.clear') }}</div>
          <div class="clearfix"></div>
        </div>

        <div class="car-tools">
          <!-- <div class="col-sm-4"></div>
              <div class="col-sm-8 dropdown">
                <el-dropdown trigger="click">
                  <el-button >
                    預設排序<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>預設排序</el-dropdown-item>
                    <el-dropdown-item divided>價格低至高</el-dropdown-item>
                    <el-dropdown-item>價格高至低</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div> -->
        </div>

        <div class="car-wrapper">
          <div class="container car-box">
            <div class="row flex">
              <van-loading type="spinner" style="margin: 20px auto;" size="50px" v-if="vanloading" />

              <van-empty image="error" :description="$t('search.description')" v-if="showC && vanloading == false" />
              <div class="aui-list col-sm-6 col-md-4 col-lg-3" v-for="(item, index) in tableData.list" :key="item.id"
                v-if="!vanloading">

                <div :class="['car-t', item.carStatus == 1 ? locale == 'en' ? 'bg bgEn' : 'bg' : '']">
                  <div :class="['swiper-container', 'swiper' + index]">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="itemImg in item.carImgUrls.slice(0, 3)"
                        :key="url + itemImg">
                        <a @click="onRouter(item)" class="lazy swiper-lazy" :data-background="url + itemImg"
                          :alt="item.carModelName"></a>
                        <div class="swiper-lazy-preloader"></div>
                      </div>
                    </div>
                  </div>
                  <div :class="['swiper-button-next iconfontmy icon-enter', 'swiper-button-next' + index]"></div>
                  <div :class="['swiper-button-prev iconfontmy icon-return', 'swiper-button-prev' + index]"></div>
                  <div :class="['swiper-pagination' + index, 'my-bullet']"></div>
                </div>
                <div :class="['car-b', item.carType === 2 ? 'ev' : '']">
                  <h3 :class="['aui-headline-3', 'car-title', locale === 'en' ? 'en' : '']"><a @click="onRouter(item)">
                      {{ locale == 'en' ? `${item.carBrandEn} ${item.carStyleEn} ${item.year}` : `${item.carBrand}
                      ${item.carStyleName} ${item.year}` }}
                      <i class="iconfont red">&#xe62e;</i></a></h3>
                  <ul class="car-specs">
                    <li><span class="spec-key">{{ $t('search.car.year') }}</span><span class="spec-val">{{ item.year
                        }}</span></li>
                    <li><span class="spec-key">{{ $t('search.car.mileage') }}</span><span class="spec-val">{{
                      item.mileage | NumFormat }} {{ $t('search.car.km') }}</span></li>
                    <li><span class="spec-key">{{ $t('search.car.fueltype') }}</span><span class="spec-val">{{ locale ==
                      'en' || item.fuelTypeCn == '' || item.fuelTypeCn == null ? item.fuelType :
                      item.fuelTypeCn }}</span></li>
                    <li><span class="spec-key" style="float: left">{{ $t('search.car.price') }}</span>{{ locale == 'en'
                      ?
                      '&nbsp;' : '' }}<span class="spec-val original" style="position: relative;"
                        v-show="item.originalPrice == null || item.originalPrice == '' ? false : true">
                          ${{item.originalPrice | NumFormatPrice }}
                          <span class="spec-val currentPrice" v-if="!item.originalPrice == null || !item.originalPrice == '' ? true : false">${{ item.currentPrice | NumFormatPrice }}</span>
                        </span>
                        <span class="spec-val currentPrice2" v-if="item.originalPrice == null || item.originalPrice == '' ? true : false">${{ item.currentPrice | NumFormatPrice }}</span>
                    </li>
                    <li><span class="spec-key">{{ $t('search.car.enginecapacity') }}</span><span class="spec-val">{{
                      locale
                        == 'en' || item.engineCapacityCn == '' || item.engineCapacityCn == null ? item.engineCapacity :
                        item.engineCapacityCn }}</span></li>
                  </ul>
                  <div class="cta-btns">
                    <a @click="onRouter(item)" class="aui-button">
                      <span class="aui-button__text">{{ $t('search.car.more') }} <i class="iconfont">&#xe610;</i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-pagination v-if="!vanloading" v-model="currentPage" :page-count="pageCount"
          @change="changeCurrentPage($event)" mode="simple" :prev-text="$t('search.prev')"
          :next-text="$t('search.next')" />
      </div>
    </div>
    <div hidden>KLM Pre-owned Cars</div>
  </section>
</template>

<script>
import Swiper from "swiper"
import { reqBanners, reqGetCarInventoryList, reqGetCarSeriesAndModels, reqGetBrandsList } from "../untils/api"
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

let vm = null
export default {
  metaInfo: {
    title: 'KLM Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'KLM Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'KLM Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
    // link: [{ // set link
    //   rel: 'asstes',
    //   href: 'https://assets-cdn.github.com/'
    // }]
  },
  name: "Search",
  inject: ['reload'],
  data() {
    return {
      metaData: 'KLM Pre-owned Cars',
      url: this.$store.state.baseURL + '/otherusedcar/',
      // banner
      // swiperSlides: {},
      swiperSlides: [],
      locale: this.$store.state.locale,
      fueltypeId: null,
      typeElectricLists: [
        { id: 1, name: '電油車', nameEn: 'Petrol' },
        { id: 2, name: '電動車', nameEn: 'Electric' },
        { id: 3, name: '柴油車', nameEn: 'Diesel' }
      ],  //车型类型
      carBrandList: [], //品牌数组
      carBrandId: null, // 品牌选中id
      carSeriesAndModelsList: [], //车系数组
      carSeriesId: null, // 车系选中id
      //年份区间
      yearValue: [],
      yearText: '',
      yearTitle: '',
      //公里数区间
      mileageValue: [],
      mileageText: '',
      mileageTitle: '',
      //价格数区间
      pricesList: [
        { txt: '50,000以下', priceValue: [0, 49999], txtEn: 'Under 50,000' },
        { txt: '50,000–100,000', priceValue: [50000, 100000], txtEn: '' },
        { txt: '100,001-150,000', priceValue: [100001, 150000], txtEn: '' },
        { txt: '150,001-200,000', priceValue: [150001, 200000], txtEn: '' },
        { txt: '200,001-300,000', priceValue: [200001, 300000], txtEn: '' },
        { txt: '300,001-400,000', priceValue: [300001, 400000], txtEn: '' },
        { txt: '400,001-600,000', priceValue: [400001, 600000], txtEn: '' },
        { txt: '600,001-1,000,000', priceValue: [600001, 1000000], txtEn: '' },
        { txt: '1,000,000以上', priceValue: [1000001, 9999999], txtEn: 'Over 1,000,000' },
      ], //价格数组
      pricesCuttent: null,
      priceValue: [],
      priceText: '',
      priceTitle: '',
      tableData: [], //返回的结果集合
      pageCount: 0,  //一共多少页
      currentPage: 1, //当前页
      pageSize: 12,  //一页展示多少
      total: 0,  //一共多少条数据
      showC: false,
      vanloading: true,

      carStatusLists: [
        { id: 0, name: '未售', nameEn: 'Available' },
        { id: 1, name: '已售', nameEn: 'Sold' }
      ],  //车型类型
      carStatus: 0

    };
  },
  created() {
  },
  async mounted() {
    let that = this
    PubSub.subscribe('locale', (msg, data) => {
      if (data.locale != '') {
        this.reload()
        this.$validator.locale = this.$store.state.locale
        // that.metaOff = true
      }
    })


    setTimeout(() => {
      that.vanloading = false
      // that.initSwiper()
    }, 500)

    // that.car()

    // that.carSeriesAndModels()
    that.carInventoryList()
    that.carBrandsList()

    let resBanners = await reqBanners()
    that.swiperSlides = resBanners.data.banners
  },
  methods: {
    //锚点跳转
    jump() {
      let jump = document.getElementById('main')
      let total = jump.offsetTop
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      let step = 50

      if (total < distance) {
        smoothUp()
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 5)
        }
      }
    },
    See(e) {
      if (e == "" || e == null) {
        window.open(e, "javascript:;");
      } else {
        window.open(e, "_blank");
      }
      // window.location.href = e
    },
    onRouter(item) {
      // 发布消息
      PubSub.publish('on', { url: 'search', on: 'on' })

      this.$store.commit('$_setCar', item)
      this.$router.push({ name: 'Detail', params: { id: item.id } })
      // window.open(routeUrl.href, '_blank')
    },
    dataFun() {
      let data = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        // carSeriesId: this.carSeriesId,
        carStatus: this.carStatus == 0 || this.carStatus ? [this.carStatus] : [0, 1],
        carBrandId: this.carBrandId,
        yearBegin: this.yearValue[0],
        yearEnd: this.yearValue[1],
        mileageBegin: this.mileageValue[0],
        mileageEnd: this.mileageValue[1],
        priceBegin: this.priceValue[0],
        priceEnd: this.priceValue[1],
        carType: this.fueltypeId
      }
      return data
    },
    //品牌
    async carBrandsList() {
      let res = await reqGetBrandsList()
      this.carBrandsList = res.data.brands
    },
    //车型车款
    async carSeriesAndModels() {
      let res = await reqGetCarSeriesAndModels()
      this.carSeriesAndModelsList = res.data.carSeriesAndModels
    },
    async carInventoryList(data) {
      let that = this
      if (data == null || data == undefined) {
        this.currentPage = 1
        data = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          carStatus: [0],  //显示在售
        }
        that.fueltypeId = null
        that.carSeriesId = null
        //品牌
        that.carBrandId = null
        //年份区间
        that.yearValue = [2000, new Date().getFullYear()]
        that.yearText = ''
        that.yearTitle = this.$t('search.wrapper.year_by')
        //公里数区间
        that.mileageValue = [0, 150000]
        that.mileageText = ''
        that.mileageTitle = this.$t('search.wrapper.mileage_by')
        //价格数区间
        if (that.pricesCuttent == null) {
          that.priceValue = [null, null]
        }
        that.pricesCuttent = null

        // that.priceValue = [null, null]
        // that.priceText = ''
        // that.priceTitle = 'By Price'
        that.changeYear()
        that.changeMileage()
        // that.changePrice()
      }

      that.vanloading = true
      let res = await reqGetCarInventoryList(data)
      if (res.code == 200) {
        that.tableData = res.data.carInventoryList
        if (that.tableData.list.length != 0) {
          that.tableData.list.forEach((val, i) => {
            if (val.thumbnailUrls != null) {
              that.tableData.list[i].currentPrice = val.currentPrice
              that.tableData.list[i].thumbnailUrls = val.thumbnailUrls.split(';')
              that.tableData.list[i].carImgUrls = val.carImgUrls.split(';')
              that.tableData.list[i].thumbnailUrls.forEach((valList, imgIndex) => {
                if (valList == '') {
                  that.tableData.list[i].thumbnailUrls.splice(imgIndex, 1)
                }
              })
              that.tableData.list[i].carImgUrls.forEach((valList2, imgIndex2) => {
                if (valList2 == '') {
                  that.tableData.list[i].carImgUrls.splice(imgIndex2, 1)
                }
              })
            } else {
              that.tableData.list[i].carImgUrls = []
            }
          })
          that.showC = false
        } else {
          that.showC = true
        }

        setTimeout(() => {
          that.vanloading = false
          that.$nextTick(() => {
            that.tableData.list.forEach((val, i) => {
              // mySwiper.slideTo
              that.swiper(i)
            })
          })
        }, 300)

        that.pageCount = res.data.carInventoryList.pages
        that.total = res.data.carInventoryList.total
      }
    },
    initSwiper() {
      new Swiper(".swiper-container-a", {
        effect: "slide",
        spaceBetween: 30,
        // autoHeight: true,
        observer: true,
        observeParents: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination-a",
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next-a', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev-a', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
        // autoplay: 5000,
        autoplay: {
          delay: 5000, // 设置轮播的时间
          disableOnInteraction: false, // 这一行是为了避免手动滑动轮播图后，自动轮播失效，默认为true
        },
        // direction:"horizontal", /*横向滑动*/
        // loop:true, //形成环路（即：可以从最后一张图跳转到第一张图
        // pagination:".swiper-pagination", /*分页器*/
        // autoplay:3000 /*每隔3秒自动播放*/
      });
      this.show = true
      PubSub.publish('show', this.show)
    },
    swiper(s) {
      let mySwiper = new Swiper('.swiper' + s, {
        speed: 350,
        zoom: true,
        loop: true,
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper    
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
          checkInView: true,
        },
        navigation: {
          nextEl: '.swiper-button-next' + s, //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev' + s, //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
        pagination: {
          el: '.swiper-pagination' + s,
          bulletClass: 'my-bullet-li',//需设置.my-bullet-li样式
          hideOnClick: false, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
          clickable: true, //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
        }
      })

      // slideChange
      mySwiper.on('slideChange', function () {
        if (this.activeIndex == 4) {
          setTimeout(() => {
            mySwiper.slideTo(1, 350, false)
          }, 0)
        }
        if (this.activeIndex == 0) {
          setTimeout(() => {
            mySwiper.slideTo(3, 350, false)
          }, 0)
        }
      })
    },
    //分页
    changeCurrentPage(event) {
      let that = this
      that.currentPage = event
      let data = this.dataFun()

      that.carInventoryList(data)

      that.jump()
    },

    //查询
    // querySeries(carSeriesId) {
    //   this.tableData = []
    //   this.carSeriesId = carSeriesId
    //   // this.reload()
    //   let data = {
    //     currentPage: this.currentPage, 
    //     pageSize: this.pageSize,
    //     carSeriesId: this.carSeriesId,
    //     yearBegin: this.yearValue[0],
    //     yearEnd: this.yearValue[1],
    //     mileageBegin: this.mileageValue[0],
    //     mileageEnd: this.mileageValue[1],
    //     priceBegin: this.priceValue[0],
    //     priceEnd: this.priceValue[1]
    //   }
    //   this.carInventoryList(data)
    // },
    queryElectric(fueltypeId) {
      this.tableData = []
      this.fueltypeId = fueltypeId
      this.currentPage = 1
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    queryCarStatus(carStatus) {
      this.tableData = []
      this.carStatus = carStatus
      // if(carStatus == null || carStatus == '') this.carStatus = [0,1]
      this.currentPage = 1
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    //品牌
    queryBrand(carBrandId) {
      this.tableData = []
      this.carBrandId = carBrandId
      this.currentPage = 1
      // this.reload()
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    //年份
    changeYear(on) {
      this.yearText = this.yearValue[0] + ' - ' + this.yearValue[1]
      if (on == 'on') {
        this.yearTitle = this.yearValue[0] + ' - ' + this.yearValue[1]
      }
    },
    getYear() {
      this.currentPage = 1
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    //里程
    changeMileage(on) {
      var intPart1 = Number(this.mileageValue[0]).toFixed(0); //获取整数部分
      var intPartFormat1 = intPart1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
      var intPart2 = Number(this.mileageValue[1]).toFixed(0); //获取整数部分
      var intPartFormat2 = intPart2.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

      this.mileageText = intPartFormat1 + '-' + intPartFormat2
      if (on == 'on') {
        this.mileageTitle = this.mileageText
      }
    },
    getMileage() {
      this.currentPage = 1
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    //价格
    queryPrice(pricesCuttent) {
      this.tableData = []
      this.pricesCuttent = pricesCuttent
      if (this.pricesCuttent == 'null' || this.pricesCuttent == null) {
        this.priceValue = [null, null]
      } else {
        this.priceValue = [pricesCuttent[0], pricesCuttent[1]]
      }
      this.currentPage = 1
      let data = this.dataFun()
      this.carInventoryList(data)
    },
    // changePrice(on) {
    //   var intPart1 = Number(this.priceValue[0]).toFixed(0); //获取整数部分
    //   var intPartFormat1 = intPart1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    //   var intPart2 = Number(this.priceValue[1]).toFixed(0); //获取整数部分
    //   var intPartFormat2 = intPart2.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    //   this.priceText = intPartFormat1 + '-' + intPartFormat2
    //   if (on == 'on') {
    //     this.priceTitle = this.priceText
    //   }
    // },
    // getPrice() {
    //   this.currentPage = 1
    //   let data = {
    //     currentPage: this.currentPage, 
    //     pageSize: this.pageSize,
    //     carSeriesId: this.carSeriesId,
    //     yearBegin: this.yearValue[0],
    //     yearEnd: this.yearValue[1],
    //     mileageBegin: this.mileageValue[0],
    //     mileageEnd: this.mileageValue[1],
    //     priceBegin: this.priceValue[0],
    //     priceEnd: this.priceValue[1],
    //     carType: this.fueltypeId
    //   }
    //   this.carInventoryList(data)
    // },

  },
  created() {
    vm = this
  },
  computed: {
  },
  components: {
    VueSlider
  },
  // watch: {
  //   tableData: {
  //     handler(newValue, oldValue){
  //       // console.log('newValue', newValue)
  //       // console.log('oldValue', oldValue)
  //       this.table = newValue
  //       // for (let i = 0; i < newValue.length; i++) {
  //       //   if(oldValue[i] != newValue[i]) {
  //       //   console.log(newValue)
  //       //   }
  //       // }
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped>
.el-popper[x-placement^="bottom"] {
  margin-top: 2px !important;
}

.select-option .popper__arrow {
  display: none !important;
}

.select-option .el-select-dropdown__list {
  padding: 2px !important;
}

.el-select-dropdown__item.selected {
  color: #fff !important;
  background-color: #ae0526 !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #f5f7fa;
}

.el-input input::-webkit-input-placeholder {
  color: #707070 !important;
}

.el-input input::-moz-input-placeholder {
  color: #707070 !important;
}

.el-input input::-ms-input-placeholder {
  color: #707070 !important;
}

#search>>>.vue-slider-process {
  background-color: #ae0526 !important;
}

#search>>>.vue-slider-dot-tooltip-inner {
  border-color: #ae0526 !important;
  background-color: #ae0526 !important;
}
</style>

<style scoped lang="scss">
.lazy[lazy='loading'], .lazy[lazy='error'] {
  background-size: 200px !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
}

img[lazy=loading] {
  height: 100px !important;
}

img[lazy=loaded] {
  height: inherit;
}

img[lazy=error] {
  height: 200px !important;
}

h5 {
  font-size: 16px;
  line-height: 1.5;
}

.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #ee0a24;
  border-radius: 100px;
}

a {
  cursor: pointer;
}

/deep/ .van-pagination {
  width: 30%;
  margin: 58px auto 0;
}

/deep/ .van-pagination__item {
  min-width: 100px !important;
  color: #ae0526 !important;
}

/deep/ .van-pagination__item:hover {
  color: #fff !important;
  background-color: #ae0526 !important;
}

/deep/ .van-pagination__item:active {
  color: #fff !important;
  background-color: #ae0526 !important;
}

.el-select {
  width: 100%;
}

/deep/ .el-input__inner {
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
}

/deep/ .el-icon-arrow-up:before {
  display: none !important;
}

#banner {
  text-align: center;
  overflow: hidden;
}

#banner {
  // margin: 0 auto;
  margin: 0 auto 0;
  position: relative;
  // width: 1440px;
  width: 100%;
  background: #fff;

  .boxa {
    width: 100%;
    height: 100%;
    display: inline-block;

    .bg {
      span {
        font-family: 'AttenNewRegular', 'Source Han Sans CN';
        font-size: 19px;
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
        padding: 8px 10px;
        width: 100%;
        display: inline-block;
      }
    }

    img {
      width: 100%;
      // max-width: 1440px;
      margin: 0 auto;
    }
  }

  .swiper-slide {
    background: #fff;
  }

  .swiper-container-a {
    // overflow: initial;
    .swiper-wrapper {
      // height: auto;
      cursor: pointer;
    }
  }

  .swiper-pagination {
    width: 100%;
    bottom: 16px;
    // padding: 5px 0;
  }

  .swiper-button-prev-a {
    left: 8px;
  }

  .swiper-button-next-a {
    right: 8px;
  }

  .swiper-button-next-a, .swiper-button-prev-a {
    padding: 0 6px;
    width: auto;
    height: 46px;
    line-height: 46px;
    opacity: 0.9;
    color: #fff;
    background-image: none;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    cursor: pointer;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;

    &::before {
      font-size: 20px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.2);
      opacity: 1;
    }
  }
}

#search {
  position: relative;
  z-index: 2;
}

#search .flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  // justify-content: space-between;
}

#search .selector-wrapper {
  margin-bottom: 30px;
}

#search .range-outer-wrapper {
  position: relative;
  width: 200px;
  // height: 36px;
  // line-height: 36px;
  height: 42px;
  line-height: 42px;
  border: 1px solid #dedede;
  float: left;
  box-shadow: none;
  background-image: url('../images/arrow.png');
  background-position: right 10px center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-color: #fff;
  border-radius: 0;
  padding-left: 30px;
  margin-right: 10px;
  color: #707070;
}

#search .range-outer-wrapper>p {
  width: 80%;
  height: 100%;
  overflow: hidden;
  text-overflow: clip;
}

#search .range-outer-wrapper:before {
  position: absolute;
  content: '';
  left: 6.5px;
  // top: 8px;
  top: 13px;
  width: 17px;
  height: 17px;
  background-image: url('../images/search-icon.png');
}

#search #model, #search #price {
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  width: 100%;
  height: 42px;
  line-height: 42px;
  // width: 168px;
  width: 100%;
  color: #707070;
  cursor: pointer;
}

#search .range-wrapper {
  position: absolute;
  left: -1px;
  top: 42px;
  border: 1px #dedede solid;
  // width: 270px;
  width: 100%;
  padding: 10px 15px;
  background-color: #fff;
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  background-color: #FFF;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 9999;
  display: none;
}

#search .range-outer-wrapper:hover .range-wrapper {
  display: block;
}

#search .clear {
  float: left;
  // width: 60px;
  width: 6%;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background-color: #666;
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: #888;
  }
}

#search .num-wrapper {
  overflow: hidden;
}

#search .num-wrapper p {
  line-height: 25px;
  float: left;
  color: #000;
  font-size: 10pt;
}

#search .num-wrapper input {
  height: 25px;
  line-height: 25px;
  float: right;
  color: #000;
  border: 0;
  width: 144px;
  text-align: right;
  font-size: 10pt;
}

.el-dropdown-menu {
  padding: 2px 0 0 0;
}

// 排序按钮
.el-dropdown-menu .el-dropdown-menu__item {
  padding: 0 12px;

  &:hover {
    background-color: #cf002e;
    color: #fff;
  }
}

.el-dropdown-menu .el-dropdown-menu__item--divided {
  margin-top: 0;

  &:before {
    height: 1px;
    margin: 0 -12px;
  }
}

.car-tools {
  margin-bottom: 20px;
  overflow: hidden;

  .dropdown {
    text-align: right;
    padding-right: 0;

    & >>> .el-dropdown {
      .el-button {
        font-size: 14px;
        padding: 10px 12px;
        border-radius: 1;

        &:hover, &:focus {
          background-color: #eee;
          border-color: #ddd;
          color: #333;
        }
      }

      .el-button--primary {
        background-color: #fff;
        border-color: #ddd;
        border-radius: 0;
        color: #333;
      }
    }
  }
}

// 列表
.van-empty {
  margin: 0 auto;
}

.car-box {
  width: 100%;
}

.car-wrapper {
  .aui-list {
    margin-bottom: 14px;
    padding: 0 16px;

    .car-flex {
      .bg {
      }
    }

    .car-t {
      overflow: hidden;
      width: 100%;
      position: relative;

      .swiper-container {
        cursor: pointer;
      }

      .swiper-container >>> .swiper-slide {
        height: auto;
        background: #eee;

        .lazy {
          width: 100%;
          // height: 100%;
          // padding-top: 100%;
          padding-top: 75%;
          background: #eee;
          display: block;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          // opacity: 0;
          transition: opacity 0.4s ease;
        }
      }

      .swiper-button-prev {
        left: 0;
      }

      .swiper-button-next {
        right: 0;
      }

      .swiper-button-next, .swiper-button-prev {
        padding: 0 4px;
        width: auto;
        line-height: 44px;
        opacity: 0.9;
        color: #fff;
        background-image: none;
        background: rgba(0, 0, 0, 0.1);
        display: flex;
        cursor: pointer;
        -webkit-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;

        &::before {
          font-size: 20px;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.2);
          opacity: 1;
        }
      }

      .my-bullet {
        width: 100%;
        height: 20px;
        position: absolute;
        bottom: 0;
        z-index: 99;
        display: flex;
        justify-content: center;
      }

      .my-bullet >>> .my-bullet-li {
        width: 30px;
        height: 10px;
        float: left;
        margin: 0px 2px;
        background: rgba(102, 102, 102, 0.5);
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
        -webkit-backface-visibility: visible;
        -webkit-transition: background-color 0.2s ease;
        -o-transition: background-color 0.2s ease;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 0.8);
        }
      }

      .my-bullet >>> .swiper-pagination-bullet-active {
        background-color: rgba(255, 255, 255, 0.8);
        opacity: 1;
      }

      &:hover {
        .swiper-button-next, .swiper-button-prev {
          opacity: 1;
        }
      }
    }

    .car-t.bg::before {
      display: block;
      content: '';
      position: absolute;
      top: -12px;
      left: -12px;
      z-index: 999;
      width: 80px;
      height: 48px;
      background: #ae0526;
      -webkit-transform: skewX(-26deg);
      transform: skewX(-26deg);
    }

    .car-t.bg::after {
      margin-left: 0;
      margin-top: 6px;
      display: block;
      content: '已售';
      position: absolute;
      top: 0;
      left: 12px;
      z-index: 999;
      color: #fff;
      font-size: 20px;
    }

    .car-t.bgEn::after {
      content: 'Sold';
    }

    // .car-t::before {
    // display: block;
    // content: '';
    // position: absolute;
    // top: 0;
    // left: 0;
    // z-index: 999;
    // width: 100%;
    // height: 40px;
    // background: #ae0526;
    // transform: skewX(-48deg);
    // }
    // .car-t::after {
    // margin-left: -22px;
    // margin-top: 6px;
    // display: block;
    // content: '已售';
    // position: absolute;;
    // top: 0;
    // left: 50%;
    // z-index: 999;
    // color: #fff;
    // font-size: 24px;
    // }
    // .car-t::before {
    // display: block;
    // content: ''
    // position: absolute;
    // top: 0;
    // left: 0;
    // z-index: 999;
    // width: 100%;
    // height: 100%;
    // background: rgba(0, 0, 0, 0.6)
    // }
    // .car-t::after {
    // margin-top: -24px;
    // margin-left: -40px;
    // display: block;
    // content: '已售'
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // z-index: 999;
    // width: 100%;
    // height: 100%;
    // color: #fff;
    // font-size: 40px;
    // }
    
    .ev {
      position: relative;
      &::before  {
        content: " ";
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100px;
        height: 100px;
        background-image: url('../images/icon_ev.png');
        background-size: 60%;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .car-title {
        &::after  {
          content: "電動車";
          display: block;
          position: absolute;
          top: 19px;
          left: 0;
          font-size: 13px;
          font-weight: 300;
          color: #1aad19;
        }
      }
      .en {
        &::after  {
          content: "Electric Vehicle";
        }
      }
    }
    .car-b {
      .car-title {
        margin: 14px 0 6px;
        padding-bottom: 9px;
        font-size: 17px;
        font-weight: 700;
        // letter-spacing: -1px;

        a {
          font-family: 'AttenNewRegular', 'Source Han Sans CN';
          color: inherit;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          padding-right: 14px;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          -webkit-transition: text-decoration 0.35s ease-in-out;
          -moz-transition: text-decoration 0.35s ease-in-out;
          -ms-transition: text-decoration 0.35s ease-in-out;
          -o-transition: text-decoration 0.35s ease-in-out;
          transition: text-decoration 0.35s ease-in-out;

          i {
            margin-left: 6px;
            font-size: 12px;
            position: relative;
            bottom: 2px;
            -webkit-font-smoothing: antialiased;
            display: inline-block;
            font-style: normal;
            font-variant: normal;
            text-rendering: auto;
          }

          .red {
            color: #dc3545;
          }

          &:visited, &:hover {
            i {
              text-decoration: none;
            }
          }
        }
      }
      

      .car-specs {
        list-style: none;
        margin: 0;
        padding: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;

        .spec-key {
          font-size: 14px;
          color: #000;
        }
        .currentPrice, .currentPrice2 {
          font-size: 16px;
          line-height: normal;
          color: #ae0526;
          font-weight: 600;
        }

        .currentPrice{
          position: absolute;
          top: 26px;
          left: 0;
          // right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          // color: #333;
        }
        .currentPrice2{
          position: relative;
        }
        
        .original {
          color: #999;
          text-decoration: line-through;
          text-decoration-line: line-through;
          text-decoration-color: #999;
          -moz-text-decoration-color: #999;
        }

        li {
          width: 48%;
          margin: 0;
          padding: 0;
          color: #333;
          font-size: 14px;
          font-weight: 300;
          line-height: 1.68;

          &:last-of-type {
            width: 100%;
          }

          &:nth-child(even) {
            width: 52%;
          }
        }
      }

      .cta-btns {
        .aui-button {
          color: #fff;
          stroke: #fff;
          fill: #fff;
          border: 1px solid transparent;
          background: #4e5256;
          border-radius: 0;
          cursor: pointer;
          display: inline-block;
          position: relative;
          padding: 3px 4px;
          margin-top: 8px;
          outline: 0;
          text-align: center;
          text-decoration: none;
          white-space: normal;
          vertical-align: middle;
          transition: all 0.3s cubic-bezier(0.75, 0.02, 0.5, 1);
          -webkit-tap-highlight-color: transparent;
          -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

          &:hover {
            color: #fff;
            stroke: #fff;
            fill: #fff;
            background: #ae0526;
          }

          .aui-button__text {
            display: inline-block;
            position: relative;
            font-family: inherit;
            font-size: 15px;
            font-weight: 400;
            // line-height: 20px;
            text-align: left;

            i {
              position: relative;
              top: 1px;
              left: -4px;
              transition: left 0.2s ease;
            }

            &:hover {
              i {
                left: 4px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  img[lazy=loading] {
    height: 150px !important;
  }

  /deep/ .van-pagination {
    width: 80%;
  }

  /* search */
  #search .selector-wrapper {
    // margin-top: 10px;
    margin-top: 16px;
  }

  #search .range-outer-wrapper {
    width: 100%;
    margin-bottom: 20px;
  }

  #search #model, #search #price {
    padding: 0;
  }

  #search #model, #search #price, #search .range-wrapper {
    width: 100%;
  }

  #search .car-img {
    width: 49.5%;
    float: left;
    padding-right: 0;
    margin-bottom: 1%;
    padding-bottom: 0;
  }

  #search .car-img:nth-child(odd) {
    margin-right: 1%;
  }

  #search .car-detail-content .left-col {
    float: left;
  }

  #search .car-detail-content .right-col {
    float: right;
    max-width: 240px;
  }

  #search .car-detail-content .right-col.car-label {
    max-width: none;
  }

  #search .car-detail-content .left-col.feature, #search .car-detail-content .left-col.feature-textarea, #search .car-detail-content .right-col.feature, #search .car-detail-content .right-col.feature-textarea {
    float: none;
    max-width: 100%;
  }

  #search a.more {
    display: block;
    margin-left: 0;
  }

  #search .detail-btn {
    margin-top: 50px;
  }

  #search .car-big-img {
    padding: 0 0 1% 0;
  }

  #search .clear {
    width: 60px;
    float: right;
  }

  .car-wrapper {
    .container {
      padding-right: 8px;
      padding-left: 8px;
    }

    .aui-list {
      margin-bottom: 18px;
      // padding: 0;
      padding: 0 8px;

      .car-t {
        .swiper-container >>> .swiper-slide {
          .lazy {
            // padding-top: 72%;
          }
        }
      }
    }
  }
}

@media (min-width: 768px) {
  #search .range-outer-wrapper {
    // width: 155px;
    // width: calc(20.5% - 10px);
    width: calc(15.5% - 10px);
    &:nth-child(1),
    &:nth-child(2) {
      width: calc(16% - 10px);
    }
  }
}
</style>


<style scoped>
.swiper-pagination .swiper-pagination-bullet {
  position: relative;
  display: inline-block;
  width: 13px;
  height: 13px;
  margin: 0 6px;
  padding: 0;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.8);
  cursor: pointer;
}

.swiper-pagination .swiper-pagination-bullet:hover {
  opacity: 0.75;
}

.swiper-pagination .swiper-pagination-bullet-active {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/Garage.vue